import useI18nText from '../hooks/useI18nText';

import type { I18nStringMap } from '@rewardopl/types';

type I18nTextProps = {
  fallbackValue: string;
  value?: I18nStringMap;
};

export default function I18nText({ fallbackValue, value }: I18nTextProps) {
  return useI18nText(value, fallbackValue);
}
